<ng-container *ngIf="instructor$ | async; let instructor">
  <section class="about-section">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-0 col-lg-4 col-xl-4">
          <div class="instructor-thum" ngImagePixel #guideImage="imagePixel">
            <img class="img-fluid"
                 src="{{guideDefaultImage(instructor)}}?{{guideImage.getImagePixel()}}&fit=crop&auto=compress,enhance"
                 alt=""/>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-7 offset-lg-1 col-xl-7 offset-xl-1">
          <div class="instructor-info">
            <div class="instructor-regions">
              <ng-container
                *ngFor="let region of instructor?.regions;last as isLast"> {{region.name}} {{isLast ? "" : "/"}} </ng-container>
            </div>
            <h2 class="instructor-name text-black">{{ instructor.firstName + ' ' + instructor.lastName}}</h2>
            <div class="px-0 col-lg-auto col-12 d-flex align-items-center align-content-center">
              <div *ngIf="instructor?.rating > 0" class="rating instructor-rating">
                <ngx-rating [rate]="instructor?.rating ?? 0" [max]="5"></ngx-rating>
              </div>
              <div class="instructor-review-count text-primary pl-2">
                {{ instructor?.reviewCount  }} <span
                *ngIf="instructor?.reviewCount !== 1">{{translationScope + '.reviews' | transloco}}</span><span
                *ngIf="instructor?.reviewCount === 1">{{translationScope + '.review' | transloco}}</span>
              </div>
            </div>
            <div class="section-item">
              <ng-container *ngIf="(userInfo$ |async)  ; else contactInfoPrompt">
                <div class="mb-0 instructor-contact">
                  <span class="pr-4">{{instructor?.email}}</span> <span>{{instructor?.phone}}</span>
                </div>
              </ng-container>
              <ng-template #contactInfoPrompt>
                <a [routerLink]="['/auth/login']">
                  {{translationScope + '.registration_or_login_prompt' | transloco}}
                </a>
              </ng-template>
            </div>
          </div>

          <div class="section-item pt-3">
            <div class="section-header">
              <h1 class="section-title">{{translationScope + '.titles.about_instructor' | transloco}}</h1>
            </div>
            <ng-container
              *ngTemplateOutlet="((instructor?.description?.length > 254) ? descriptionWithReadMore: descriptionWithoutReadMore)">
            </ng-container>
            <ng-template #descriptionWithReadMore>
              <p class="section-description" [class.expand-less]="readMoreText" [innerHTML]="instructor?.description"></p>
              <a class="about read-more my-0" (click)="readMore()">
                <ng-container *ngIf="readMoreText"><i
                  class="icon-plus ml-0"></i> {{translationScope + '.read_more' | transloco | uppercase}}</ng-container>
                <ng-container *ngIf="!readMoreText"><i
                  class="icon-minus ml-0"></i> {{translationScope + '.read_less' | transloco | uppercase}}
                </ng-container>
              </a>
            </ng-template>
            <ng-template #descriptionWithoutReadMore>
              <p class="section-description" [innerHTML]="instructor?.description"></p>
            </ng-template>
          </div>

          <div *ngIf="instructor?.courseTemplates?.length > 0" class="section-item border-bottom">
            <div class="section-header">
              <h4 class="section-title">
                Godkjent instruktør for
              </h4>
            </div>
            <div class="section-description text-primary">
              <ng-container *ngFor="let courseTemplate of instructor?.courseTemplates;last as isLast">
                <a [routerLink]="['/kursoversikt',courseTemplate.id]">
                  {{courseTemplate.title}}{{ isLast ? '' : ', '}}
                </a>
              </ng-container>
            </div>
          </div>

          <div *ngIf="instructor?.reviewCount > 0" class="section-item">
            <div class="section-header">
              <h4 class="section-title">{{translationScope + '.titles.reviews' | transloco}}</h4>
            </div>
            <div class="review-sections">
              <app-review-card
                *ngFor="let review of reviews$ | async;first as isFirst"
                [rating]="review.value"
                [name]="review?.user?.name"
                [comment]="review?.comment"
                [imageUrl]="review?.user?.image"
                [experienceName]="review?.bookingTypeTitle"
                [isFirstItem]="isFirst"
              >
              </app-review-card>
            </div>
            <div *ngIf="(instructor?.reviewCount > totalLoadedInstructorReviews)">
              <a
                class="read-more text-uppercase my-0"
                (click)="fetchMoreInstructorReviews()"
              >
                <i class="icon-plus ml-0"></i> {{translationScope + '.read_more' | transloco}}
              </a>

            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
</ng-container>


<!-- ***************************Featured Tour Start Here*************************** -->
<section class="my-experiences">
  <!-- Featured Tour Header Container-->
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="section-header">
          <h1 class="h1">
            {{translationScope + '.titles.my_courses' | transloco}}
          </h1>
        </div>
      </div>
    </div>
  </div>
  <!-- Featured Tour Header Container End-->
  <!-- Featured Tour Card Content Start-->
  <div class="section-content">
    <div class="container">
      <div class="grid">
        <!-- Featured Tour Card Big Item Start-->
        <app-course-preview-card *ngFor="let course of myClassroomCourses$ | async"
                                 class="position-relative" [size]="'small'"
                                 [course]="course"></app-course-preview-card>
      </div>
    </div>
    <!-- Featured Tour Card Content End-->
  </div>
</section>
